// Styled components
import styled from "@emotion/styled";


export const MembershipContainer = styled.div`
  margin: 2rem auto;
  max-width: 800px;
  padding: 1rem;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #555;
`;

export const Section = styled.div`
  margin-bottom: 2rem;
`;

export const Heading = styled.h2`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 0.5rem;
`;

export const Text = styled.p`
  font-size: 1rem;
  margin: 0;
`;

export const ApplyButton = styled.a`
  display: inline-block;
  background-color: #007bff;
  color: #fff;
  text-decoration: none;
  font-size: 1rem;
  padding: 0.75rem 1.5rem;
  border-radius: 5px;
  text-align: center;
  margin-top: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s;

  &:hover {
    background-color: #0056b3;
  }
`;